import "./style.css";
import { placeOrder } from "../../entities/actions";
import { useDispatch } from "react-redux";
import { Order } from "../common/Order/ProgressOrder";
import React from "react";
import { orderTypeEnum } from "../consts";
import { rnd } from "../MainPage";
import { config } from "../../config";
import { NewOrder } from "../common/Order/ProgressOrder/NewOrder";
import { getRandomLimit } from "../../utils/getRandomLimit";

export const ScenarioGrid = ({
  orders,
  simulation,
  limits,
  shouldBlockScenario
}) => {
  const dispatch = useDispatch();

  const placedOrdersCount = orders.filter(order => order.side).length;

  const handlePlaceOrder = (order, side, index) => {
    const sideValue = side === "buy" ? "BUY" : "SELL";

    const orderLimit = getRandomLimit({ limits, sideValue });

    let newSideValue = sideValue;
    if (order.side === sideValue) {
      newSideValue = "";
    }
    dispatch(
      placeOrder({
        id: order.order_id,
        side: newSideValue,
        index,
        limit: orderLimit
      })
    );
  };

  // there should be 5 orders in the grid
  const ordersCount = orders.length;
  const ordersToAddCount = 5 - ordersCount;
  const updatedOrders = [...orders];
  let idCounter = ordersCount;

  for (let i = 0; i < ordersToAddCount; i++) {
    updatedOrders.push({
      order_id: `OID${idCounter + 1}`,
      side: "",
      row: null,
      x: null,
      mark: "",
      size: 46000,
      strat: "30%",
      streamRate: {}
    });
    ++idCounter;
  }

  return (
    <div className="order-grid-container">
      <div>
        <h2 className="scenario-title">{config.scenario.title}</h2>
      </div>
      <div>
        <div className="order-grid-header">
          <div className="order-grid-label">
            {config.scenario.buyColumnTitle}
          </div>
          <div className="order-grid-label">
            {config.scenario.sellColumnTitle}
          </div>
        </div>
        {updatedOrders.map((order, index) => (
          <div
            key={`${order.order_id}-${order.side}`}
            className="order-grid-row"
          >
            <div
              className={`order-grid-cell ${shouldBlockScenario &&
                "order-grid-cell-disabled"}`}
            >
              <button
                onClick={() => handlePlaceOrder(order, "buy", index)}
                disabled={shouldBlockScenario}
              >
                {order.side === "BUY" && (
                  <NewOrder
                    side="BUY"
                    num={index + 1}
                    x={null}
                    id={order.order_id}
                    simulation={simulation}
                    ls={order.type === orderTypeEnum.lsh}
                    progress={order?.max_cap?.slice(0, -1)}
                    iconSize={20}
                    classname="order-grid-icon"
                    type={order.type}
                  />
                )}
              </button>
            </div>
            <div
              className={`order-grid-cell ${shouldBlockScenario &&
                "order-grid-cell-disabled"}`}
            >
              <button
                onClick={() => handlePlaceOrder(order, "sell", index)}
                disabled={shouldBlockScenario}
              >
                {order.side === "SELL" && (
                  <NewOrder
                    side="SELL"
                    x={null}
                    num={index + 1}
                    id={order.order_id}
                    simulation={simulation}
                    ls={order.type === orderTypeEnum.lsh}
                    progress={order?.max_cap?.slice(0, -1)}
                    iconSize={20}
                    type={order.type}
                    classname="order-grid-icon"
                  />
                )}
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
